module.exports = __webpack_public_path__ + "static/media/cases_3d_05b.cb7115bb.jpg";